import React, { useState } from "react";
import Datepicker from "../../../../components/Form/Datepicker";
import { cl } from "../../../../utilities/cl";
import { buildGETUrl } from "../../../../utilities/buildGETUrl";
import { useDispatch } from "react-redux";
import { showAlertError } from "../../../../store/Alert/actions";

const ReportDownload = ({ className = "", selectedObjects }) => {
    const dispatch = useDispatch();
    const [period, setPeriod] = useState({ from: "", to: "" });
    const [isLoading, setIsLoading] = useState(false);
    const [activeReport, setActiveReport] = useState(null);

    const handlePeriodChange = ({ from, to }) => {
        setPeriod({ from, to });
    };

    const handleReportClick = async (reportType, e) => {
        e.preventDefault();

        if (!period.from || !period.to) {
            return;
        }

        setIsLoading(true);
        setActiveReport(reportType);

        try {
            const url = buildGETUrl(`docs/report/${reportType}`, {
                ms_id: selectedObjects,
                from: period.from,
                to: period.to
            });

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Ошибка формирования отчета:', errorData);

                if (response.status === 400) {
                    dispatch(showAlertError({ text: errorData.error}))
                }
                throw new Error(errorData.error || 'Ошибка формирования отчета');
            }

            // Если ответ успешный, открываем отчет в новом окне
            window.open(url, '_blank');

        } catch (error) {
            console.error('Ошибка:', error.message);
        } finally {
            setIsLoading(false);
            setActiveReport(null);
        }
    };

    const reports = [
        {
            type: "music",
            label: "Отчет трансляции музыки",
            url: buildGETUrl("docs/report/music", {
                ms_id: selectedObjects,
                from: period.from,
                to: period.to
            })
        },
        {
            type: "rao",
            label: "Отчет для РАО",
            url: buildGETUrl("docs/report/rao", {
                ms_id: selectedObjects,
                from: period.from,
                to: period.to
            })
        },
        {
            type: "vois",
            label: "Отчет для ВОИС",
            url: buildGETUrl("docs/report/vois", {
                ms_id: selectedObjects,
                from: period.from,
                to: period.to
            })
        },
        {
            type: "cliplog",
            label: "Отчет по рекламе",
            url: buildGETUrl("docs/report/cliplog", {
                ms_id: selectedObjects,
                from: period.from,
                to: period.to
            })
        }
    ];

    // Стили в JavaScript
    const styles = {
        linksContainer: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            marginTop: '1rem'
        },
        link: {
            padding: '0.75rem 1rem',
            color: '#0d6efd',
            textDecoration: 'none',
            borderRadius: '4px',
            transition: 'all 0.2s ease',
            display: 'block'
        },
        linkHover: {
            backgroundColor: 'rgba(13, 110, 253, 0.1)'
        },
        linkDisabled: {
            color: '#6c757d',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        loadingText: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem'
        },
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        },
        spinner: {
            width: '3rem',
            height: '3rem',
            border: '4px solid rgba(10, 10, 10, 0.48)',
            borderTopColor: '#ff3347',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
        },
        spinnerText: {
            marginTop: '1rem',
            color: '#212529'
        }
    };

    // Анимация спиннера
    const spinKeyframes = `
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `;

    return (
        <div className={className}>
            <style>{spinKeyframes}</style>

            <Datepicker
                className="mb-3"
                type="between"
                durationInput={true}
                variant="icon"
                titles={{
                    main: "Период",
                    from: "Дата начала",
                    to: "Дата окончания"
                }}
                onChange={handlePeriodChange}
            />

            <div style={styles.linksContainer}>
                {reports.map((report) => {
                    const isDisabled = !period.from || !period.to || isLoading;
                    const isActiveLoading = isLoading && activeReport === report.type;

                    return (
                        <a
                            key={report.type}
                            href={report.url}
                            onClick={(e) => handleReportClick(report.type, e)}
                            className={cl("nav-link d-block", { disabled: !period.from || !period.to || isLoading })}
                            aria-disabled={isDisabled}

                        >
                            {isActiveLoading ? (
                                <span style={styles.loadingText}>
                                    <div style={styles.spinner} />
                                    Формирование отчета...
                                </span>
                            ) : (
                                report.label
                            )}
                        </a>
                    );
                })}
            </div>

            {isLoading && (
                <div style={styles.overlay}>
                    <div style={styles.spinner} />
                    <p style={styles.spinnerText}>
                        Формирование отчета {activeReport}, пожалуйста подождите...
                    </p>
                </div>
            )}
        </div>
    );
};

export default ReportDownload;